import { analyticsService } from '@common/analytics-layer/services/analytics.service'

import { CommunityTrafficAnalyticsProvider } from '../providers/community-traffic-analytics.provider'

export function registerCommunityTrafficAnalyticsProvider(): void {
  analyticsService.registerProvider('communityTrafficAnalytics', new CommunityTrafficAnalyticsProvider())
}
